export enum WBSPaymentErrorCodes {
  'WB0001' = 'WB0001',
  'WB0005' = 'WB0005',
  'WB0006' = 'WB0006',
  'WB0007' = 'WB0007',
  'WB0013' = 'WB0013',
  'WB0014' = 'WB0014',
  'WB0015' = 'WB0015',
  'WB0017' = 'WB0017',
  'WB0018' = 'WB0018',
  'WB0019' = 'WB0019',
  'WB0020' = 'WB0020',
}
